import { Button, Card } from "antd";
import { DownloadOutlined } from "@ant-design/icons";

import classes from "./PDFCard.module.scss";

export default function PDFCard({ title }) {
  return (
    <div className={classes.container}>
      <Card
        title={title}
        style={{
          width: 170,
          background: "#d1e7d5",
        }}
        styles={{
          body: {
            padding: "12px 4px",
            textAlign: "center",
            display: "flex",
            justifyContent: "space-between",
          },
          cover: {
            padding: "0 20px",
            overflow: "hidden",
            borderRadius: 12,
            opacity: 0.9,
          },
          header: {
            minHeight: 0,
            padding: "4px 0",
          },
        }}
        cover={<img alt="example" src={`/pdf/previews/${title}.jpg`} />}
      >
        <a
          href={`/pdf/${title}(EN).pdf`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button type="primary" icon={<DownloadOutlined />} size="small">
            EN
          </Button>
        </a>
        <a
          href={`/pdf/${title}(AZ).pdf`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button type="primary" icon={<DownloadOutlined />} size="small">
            AZ
          </Button>
        </a>
      </Card>
    </div>
  );
}
